import { useMutation } from 'react-query';

import { createProject as mutationFn } from 'api/endPoints/createProject';

import { ProjectTreeNode } from 'components/common/TreeProgramFilter/ProjectTree/projectTree.utils';

export const useMutationCreateProject = () => {
    return useMutation<ICreateProjectResponse, QueryError, ICreateProjectPayload>((params) => mutationFn(params));
};

export interface ICreateProjectPayload {
    projectName: string;
    projectDescription: string;
    initialContractName: string;
    userGroups: string[];
    customerId?: number;
}

export interface ICreateProjectResponse {
    id: number;
    projectUid: ProjectTreeNode['uuid'];
    name: string;
}
